import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import moment from 'moment';
import ribbonIcon from '../../resources/img/ribbon.png';
import ribbonIconActive from '../../resources/img/ribbon-active.png';
import { API_URL } from '../../../SHARED/config/apiEndpoints';
import SelectCinemap from '../../../SHARED/components/select/select.component';
import ScheduleDate from './containers/scheduledates.component';
import CinemapCarousel from '../../../SHARED/components/carousel/carousel.component';
import { slugify, arrayClone, pageViewEvent } from "../../../SHARED/helpers/general.helper";
import MapWithContainer from "../../../SHARED/components/maps/mapwithcontainer";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { storeSelectedCinemaLocation, storeSelectedHour } from '../../../SHARED/actions/filters.actions';
import { handleScheduleTicketClick } from '../../../SHARED/actions/general.actions';
import CarouselItemsSchedule from '../../../SHARED/components/carousel/carouselitemsschedule.component';
import { addMovieToFavoriteFromSchedule, removeMovieFromFavoriteFromSchedule } from '../../../SHARED/actions/movies.actions';
import { requestMoviesByAllCinemas, requestSortTypesOnCinemaSchedule, requestScheduleMoviesAll, requestMoviesByCinemaId } from '../../../SHARED/actions/schedule.actions';
import { withRouter } from 'react-router';
import Parser from 'html-react-parser';
import { LOGIN_ROUTE } from '../../../SHARED/config/routes';
import { showSpinner, hideSpinner } from '../../../SHARED/actions/loading.actions';
import Ads from "../ads/ads.component";
import { Helmet } from 'react-helmet';

class Schedule extends Component {
    constructor(props) {
        super(props);
        let cinemaId = '';
        if (!isNaN(parseInt(this.props.match.params.id, 10))) {
            cinemaId = parseInt(this.props.match.params.id, 10);
        }

        //TODO Get Filters from API
        this.state = {
            activeTab: '0',
            selectedHour: '',
            selectedCinema: {},
            selectedCinemaId: '',
            selectedMovieId: '',
            selectedDate: moment().format('YYYY-MM-DD'),
            cinemaId: cinemaId,
            showMap: false,
            windowWidth: window.innerWidth,
        };
    }

    componentWillMount() {
        this.props.showSpinner();
        window.scrollTo(0, 0);
        this.props.requestSortTypesOnCinemaSchedule();
        let payload = {};
        payload.date = moment().format('YYYY-MM-DD');
        payload.id = this.props.match.params.id;
        if (this.props.match.params.id) {
            let check = setInterval( () => {
                if(window.localStorage.getItem('access_token') && localStorage.getItem("cinema_location")) {
                    payload.selectedCinemaLocation = localStorage.getItem("cinema_location");
                    this.props.requestMoviesByCinemaId(payload);
                    clearInterval(check);
                    this.props.hideSpinner();
                }
            }, 500);  
        } else {
            let check = setInterval( () => {
                if(window.localStorage.getItem('access_token') && localStorage.getItem("cinema_location")) {
                    payload.selectedCinemaLocation = localStorage.getItem("cinema_location");
                    this.props.requestMoviesByAllCinemas(payload);
                    clearInterval(check);
                    this.props.hideSpinner();
                }
            }, 500);
        }
        window.addEventListener('resize', this.resizeWindow.bind(this));
    }

    componentDidMount(){
        if(this.props.match.params.id){
            if(this.props.cinemas){
            pageViewEvent(`Program Filme Azi ${(this.props.cinemas[0] && this.props.match.params.id) ? ` la ${this.props.cinemas[0].cinema.cinema_name}` : ''}`, window.location.href);
        }}
        else {
            pageViewEvent(`Program Filme Azi`, window.location.href);
            }
    }

    resizeWindow() {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCinemaLocation !== nextProps.selectedCinemaLocation) {
            this.props.history.push("/program");
            let payload = {};
            payload.selectedCinemaLocation = nextProps.selectedCinemaLocation;
            payload.date = moment().format('YYYY-MM-DD');
            payload.id = this.props.match.params.id;
            pageViewEvent(`Program Filme Azi`, window.location.href);
            if (this.state.activeTab.toString() === '0') {
                this.props.requestMoviesByAllCinemas(payload);
            } else {
                this.props.requestScheduleMoviesAll(payload);
            }
        }
    }


    getDataOnDateChanged(date) {
        this.setState({
            selectedDate: date
        });

        let payload = {};
        payload.selectedCinemaLocation = localStorage.getItem("cinema_location");
        payload.date = date;
        payload.id = this.props.match.params.id

        if (this.state.activeTab.toString() === '0') {
            if (this.props.match.params.id) {
                this.props.requestMoviesByCinemaId(payload);
            } else {
                this.props.requestMoviesByAllCinemas(payload);
            }
        } else {
            this.props.requestScheduleMoviesAll(payload);
        }
    }

    changeTab(tab) {
        if(this.props.match.params.id){
            this.props.history.push("/program");
        }
        let payload = {};
        payload.selectedCinemaLocation = localStorage.getItem("cinema_location");
        payload.date = this.state.selectedDate;
        payload.id = this.state.cinemaId
        if (tab === 0) {
            this.setState({
                activeTab: 0
            });
            this.props.requestMoviesByAllCinemas(payload);
        }
        if (tab === 1) {
            this.setState({
                activeTab: 1
            });
            this.props.requestScheduleMoviesAll(payload);
        }
    }

    // handleSortChanged(e) {
    //     console.log(e.target.value);
    // }

    showMap(cinema) {
        this.setState({
            showMap: true,
            selectedCinema: cinema.cinema
        });
    }

    showScheduleItemWithoutCarousel(cinema, schedule) {
        return <div className="no-carousel" key={schedule.film.film_id + schedule.schedule_dubbed_subtitled}>
            <CarouselItemsSchedule card={schedule} key={schedule.film.film_id} cinema={cinema} />
        </div>
    }

    showCinemas(cinemaWithAllData) {
        let cinema = cinemaWithAllData.cinema;
        let cast = arrayClone(cinemaWithAllData.schedule);
        let schedule = [];

        const currentHour = moment();

        cast.map((sch, i) => {
            let castElement = {film: sch.film, schedule_broadcast_hours: [], schedule_dubbed_subtitled: sch.schedule_dubbed_subtitled, schedule_film_status: sch.schedule_film_status, schedule_projection_format: sch.schedule_projection_format}
            let filteredHours = sch.schedule_broadcast_hours.filter(hour => {
                const momentHour = moment(`${this.props.selectedDate} ${hour.schedule_broadcast_hour}`, 'YYYY.MM.DD HH:mm');
                return momentHour.isAfter(currentHour)
            });
            if ( filteredHours.length > 0){
                castElement.schedule_broadcast_hours = filteredHours;
            }
            if (castElement.schedule_broadcast_hours.length > 0){
                schedule.push(castElement);
            }
        })
        if (schedule.length > 0){
        let numberOfSlides = schedule.length > 7 ? 7 : schedule.length;

        return <div className="cinema-item-container" key={cinema.cinema_id}>
            {/* <div className="select-sort-container">
                <span>Ordonează după:</span>
                {this.props.filters && <SelectCinemap values={this.props.filters} handleValueChanged={this.handleSortChanged} />}
            </div> */}
            {schedule.length >= 7 && <CinemapCarousel cinema={cinema} cards={schedule} defaultSlidesToShow={numberOfSlides} isSchedule={true} />}
            {schedule.length < 7 &&
                this.state.windowWidth > 1000 && <div className="row no-gutters">{schedule.map(schedule => this.showScheduleItemWithoutCarousel(cinema, schedule), this)}</div>}
            {schedule.length < 7 &&
                this.state.windowWidth <= 1000 && <CinemapCarousel cinema={cinema} cards={schedule} defaultSlidesToShow={numberOfSlides} isSchedule={true} />}
            <div className="cinema-title">
                <span>{cinema.cinema_name}</span>
            </div>
            <div className="cinema-address">
                <span>Adresă:</span> <span>{cinema.cinema_address_street},</span><span>{cinema.cinema_address_locality}</span>
                <span className="cinema-map-link" onClick={this.showMap.bind(this, { cinema })}>Vezi hartă</span>
            </div>
            <div className="cinema-phone">
                <span>Telefon:</span>  <span>{cinema.cinema_telephone}</span>
            </div>
        </div>
        }
    }

    buyTicketTab2(movie, schedule, scheduleHour, e) {
        e.preventDefault();
        if (schedule.schedule.cinema.cinema_ticket_sales === 1) {
            if (localStorage.getItem('login_type') === 'authenticated') {
                this.props.storeSelectedCinemaLocation(schedule.schedule.cinema.cinema_address_locality);
                const payload = {
                    projectionFormat: schedule.schedule.schedule_projection_format,
                    hour: scheduleHour.scheduleHour.schedule_broadcast_hour,
                    eventId: scheduleHour.scheduleHour.schedule_event_id,
                    scheduleId: scheduleHour.scheduleHour.schedule_id,
                    userId: localStorage.getItem("user_id"),
                    film_url: `/film/${movie.movie.film_id}/${slugify(movie.movie.film_title)}`,
                }
                this.props.handleScheduleTicketClick(payload);
                this.props.storeSelectedHour(payload);
            } else {
                this.props.history.push(LOGIN_ROUTE);
            }
        } else {
            window.open(schedule.cinemaWithSchedule.cinema.cinema_website, '_blank');
        }

        // if (this.state.selectedHour !== hour.hour) {
        //     this.setState({
        //         selectedHour: hour.hour,
        //         selectedCinemaId: cinema.cinema.cinema_id,
        //         selectedMovieId: movie.movie.film_id
        //     });
        // } else {
        //     this.setState({
        //         selectedHour: '',
        //         selectedCinemaId: '',
        //         selectedMovieId: ''
        //     });
        // }
        // const path = '/film/' + movie.movie.film_id + '/' + slugify(movie.movie.film_title);
        // this.props.history.push(path);

    }

    navigateToMoviePage(movie) {
        const path = '/film/' + movie.film_id + '/' + slugify(movie.film_title);
        this.props.history.push(path);
    }

    // This code was used for another requirements (many changes was on these section)
    // buyTicketsTab2(cinema, movie) {
    //     if (this.state.selectedCinemaId && this.state.selectedMovieId) {
    //         if (cinema.cinema_id === this.state.selectedCinemaId && movie.film_id === this.state.selectedMovieId) {
    //             // User click on selected row icon
    //         } else {
    //             window.alert('Te rog apasa butonul de la filmul selectat.');
    //         }
    //     } else {
    //         window.alert('Te rugam selecteaza un film');
    //     }
    //     // console.log(cinema.cinema_id);
    //     // console.log(movie.film_id);
    //     // console.log(this.state.selectedCinemaId);
    //     // console.log(this.state.selectedMovieId);
    //     // console.log(this.state.selectedHour);
    // }

    // addMovieOnFavourite(movie) {
    //     this.props.addMovieToFavoriteFromSchedule(movie.film_uuid);
    // }

    // removeMovieFromFavorite(movie) {
    //     this.props.removeMovieFromFavoriteFromSchedule(movie.favorite[0].uuid);
    // }

    showCinemasVertical(movieWithSchedule, i) {

        let movie = movieWithSchedule.film;
        let _self = this;

        let adsArray = [
            <Ads
                id="div-gpt-ad-1662463178982-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463314968-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463706379-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
            />,
            <Ads
                id="div-gpt-ad-1662463754517-0"
                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463754517-0'); googletag.pubads().refresh();});"
            />
        ];


        return (
            <div>
            {  i % 4 == 3 ? adsArray[Math.floor(i / 4)] : null }
                <div key={movie.film_id} className="row no-gutters all-movies-container col-12">
                    <div className="col-12 col-xl-1 col-lg-2 col-md-2 col-sm-2 cinema-image" onClick={() => this.navigateToMoviePage(movie)}>
                        <img src={API_URL + movie.film_poster} alt={'Movie'} />
                    </div>
                    {movie.schedule_film_status === 'premieră' && <div className="film_status premiera">{movie.schedule_film_status}</div>}
                    {movie.schedule_film_status === 'avan' && <div className="film_status avan">{movie.schedule_film_status}</div>}
                     <div className={`film_status ${movie.film_status === "premieră" ? "premiera" : "avan"}`}>{movie.film_status}</div>
                    <div className="col-12 col-xl-4 col-lg-4 col-md-6 col-sm-4 no-gutters movie-details-section">
                        <div>
                             {movie.favorite.length === 0 ?
                            <img className="favourites-icon" src={ribbonIcon} onClick={() => this.addMovieOnFavourite(movie)} alt={'Favorite'} /> :
                            <img className="favourites-icon" src={ribbonIconActive} onClick={() => this.removeMovieFromFavorite(movie)} alt={'Favorite'} />}
                            <span className="title">{Parser(movie.film_title)}</span>
                            <span className="release-year">({movie.film_release_year})</span>
                        </div>
                        <span className="translated-title">{movie.film_translated_title}</span>
                        <div className="movie-type-details">
                            <div className="row no-gutters first-row-border">
                                {movie.film_age_restrictions ? <span className="movie-age">{movie.film_age_restrictions}</span> : null}
                                <span className="movie-duration">{movie.film_duration}</span>
                                <span className="movie-genre">{movie.film_genre}</span>
                                <span className="movie-type">{movieWithSchedule.schedule[0].schedule_projection_format}</span>
                            </div>
                            <div className="row no-gutters">
                                <span>Premiera</span>
                                <span>{moment.unix(movie.film_release_date).format("D-MMMM-YYYY")}</span>
                            </div>
                            <div className="row no-gutters">
                                <span>Director:</span>
                                <span>{movie.film_director}</span>
                            </div>
                            <div className="row no-gutters">
                                <span>Writers:</span>
                                <span>{movie.film_scenarist}</span>
                            </div>
                            <div className="row no-gutters">
                                <span>Stars:</span>
                                <span>{movie.film_cast_short}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-xl-7 col-lg-6 col-md-4 col-sm-6">
                        <div className="cinema-schedule">
                            {movieWithSchedule.schedule.map(function (schedule, i) {
                                let cinema = schedule.cinema;
                                if (cinema) {
                                    return <div key={i} className="cinema-schedule-item">
                                        <span className="cinema-name">{cinema.cinema_name}</span>
                                        <div className="row no-gutters">
                                            {schedule.schedule_broadcast_hours.map(function (scheduleHour) {
                                                return <div key={scheduleHour.schedule_event_id}
                                                            className={`movie-details-schedule mt-2 ${cinema.cinema_id === _self.state.selectedCinemaId ? movie.film_id === _self.state.selectedMovieId ? scheduleHour === _self.state.selectedHour ? 'active' : '' : '' : ''}`}
                                                            onClick={_self.buyTicketTab2.bind(_self, { movie }, { schedule }, { scheduleHour })}>
                                                    <span className="type">{schedule.schedule_projection_format}</span>
                                                    <span className="schedule-dubbed-subtitled">{schedule.schedule_dubbed_subtitled}</span>
                                                    <span>{scheduleHour.schedule_broadcast_hour}</span>
                                                </div>
                                            })}
                                            <div className="empty"></div>
                                            <div className="icons-container">
                                                 {/*<img className="tickets-icon" src={iconTickets} />*/}
                                                 {/*{cinema.favorite.length === 0 ?*/}
                                                {/*<img className="favourites-icon" src={ribbonIcon} onClick={() => _self.addMovieOnFavouriteTab2(cinema)} /> :*/}
                                                {/*<img className="favourites-icon" src={ribbonIconActive} onClick={() => _self.removeMovieFromFavorite(cinema)} />}*/}
                                            </div>
                                        </div>
                                    </div>
                                }
                                else {
                                    return null;
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    hideMap() {
        this.setState({
            showMap: false
        });
    }

    errorMessage() {
        if (this.props.match.params.id) {
            return `Pe data selectată nu rulează nici un film in cinematograful selectat`;
        }
        else {
            return `Pe data selectată nu rulează nici un film in cinematografele din ${window.localStorage.getItem("cinema_location")}`
        }
    }

    getAllMoviesTabContent = () => {
        let cast = [];
        let cloneCast = [];
        if (this.props.scheduleAllMovies && this.props.scheduleAllMovies.length > 0){
            const currentHour = moment().locale("ro");
            cast = arrayClone(this.props.scheduleAllMovies);
            for(let i=0; i<cast.length; i++){
                let cloneCastElement = {film: cast[i].film, schedule: []}
                for(let j=0; j<cast[i].schedule.length; j++){
                    let filteredHours = cast[i].schedule[j].schedule_broadcast_hours.filter(hour => {
                        const momentHour = moment(`${this.props.selectedDate} ${hour.schedule_broadcast_hour}`, 'YYYY.MM.DD HH:mm');
                        return momentHour.isAfter(currentHour)
                    }); 
                    cast[i].schedule[j].schedule_broadcast_hours = filteredHours;
                    if(cast[i].schedule[j].schedule_broadcast_hours.length > 0){
                        cloneCastElement.schedule.push(cast[i].schedule[j]);
                    }
                }
                if (cloneCastElement.schedule.length !== 0){
                    cloneCast.push(cloneCastElement);
                }  
            }
        }

        return (
            <Fragment>
                 {cast && cast.length !== 0 && cloneCast.map((elem, i) => this.showCinemasVertical(elem, i), this)}
                {this.props.scheduleAllMovies && this.props.scheduleAllMovies.length === 0 && <div className="schedule-no-results">{this.errorMessage()}</div>}
            </Fragment>
        )
    }

    render() {
        return (
            <div className="schedule-container">
                {this.props.loading !== 0 ? <Spinner /> : ''}
                {this.props.match.params.id && this.props.cinemas ?                 
                <Helmet>
                    <title>{`Program Filme Azi${(this.props.cinemas[0] && this.props.match.params.id) ? ` la ${this.props.cinemas[0].cinema.cinema_name}` : ''}`}</title>
                    <meta name='description' content={`Vezi Programul Filmelor${(this.props.cinemas[0] && this.props.match.params.id) ? ` la ${this.props.cinemas[0].cinema.cinema_name}` : ''}! Cele mai noi filme, drame, comedii, thriller, SF și de dragoste.`}/>
                    <link rel='canonical' href={window.location.href} />
                </Helmet> :
                <Helmet>
                    <title>{'Program Filme Azi'}</title>
                    <meta name='description' content={'Vezi Programul Filmelor! Cele mai noi filme, drame, comedii, thriller, SF și de dragoste.'}/>
                    <link rel='canonical' href={window.location.href} />
                </Helmet>}
                <div className="title-and-schedule-container">
                    <div className="title">Program Filme</div>
                    <ScheduleDate onDateChanged={this.getDataOnDateChanged.bind(this)} />
                </div>
                <div className="schedule-cinema-container">
                    <Tabs onSelect={this.changeTab.bind(this)}>
                        <TabList>
                            <Tab>
                                <button className="schedule-button">PROGRAMUL FILMELOR PE CINEMATOGRAFE</button>
                            </Tab>
                            <Tab> <button className="schedule-button">PROGRAMUL TUTUROR FILMELOR</button></Tab>
                        </TabList>
                        <TabPanel>
                        {   window.innerWidth > 1000 ? 
                            <Ads
                                id="div-gpt-ad-1662463178982-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                            /> : 
                            <Ads
                                id="div-gpt-ad-1662463706379-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                            />
                        }
                            {this.props.cinemas && this.props.cinemas.length !== 0 && this.props.cinemas.map(this.showCinemas, this)}
                            {this.props.cinemas && this.props.cinemas.length === 0 && <div className="schedule-no-results">{this.errorMessage()}</div>}
                            <Ads
                                id="div-gpt-ad-1662463314968-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); });"
                            />
                        </TabPanel>
                        <TabPanel>
                           {this.getAllMoviesTabContent()}
                        </TabPanel>
                    </Tabs>
                </div>
                {this.state.showMap && <MapWithContainer
                    coordinates={this.state.selectedCinema.cinema_geolocation}
                    title={this.state.selectedCinema.cinema_name}
                    address={this.state.selectedCinema.cinema_address_street + ', ' + this.state.selectedCinema.cinema_address_locality}
                    phone={this.state.selectedCinema.cinema_telephone}
                    closeMap={this.hideMap.bind(this)}
                />}
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    filters: state.schedule.filters,
    cinemas: state.schedule.movies,
    scheduleAllMovies: state.schedule.scheduleAllMovies,
    selectedCinemaLocation: state.filters.selectedCinemaLocation,
    selectedDate: state.filters.reservetionSelectedDate
});
export default withRouter(connect(mapStateToProps, {showSpinner, hideSpinner, requestMoviesByAllCinemas, requestSortTypesOnCinemaSchedule, requestScheduleMoviesAll, requestMoviesByCinemaId, addMovieToFavoriteFromSchedule, removeMovieFromFavoriteFromSchedule, storeSelectedCinemaLocation, handleScheduleTicketClick, storeSelectedHour })(Schedule));



// WEBPACK FOOTER //
// ./src/FO/components/schedule/schedule.component.js